import { SB } from '@play-co/replicant';

export default {
  gifts: SB.object({
    // List of sent gifts
    sent: SB.map(
      // Sent gifts list, key is target user id
      SB.object({
        // When message was sent last time
        sentAt: SB.int(),
      }),
    ),

    // List of received gifts with user ID key
    received: SB.map(
      // Gift model
      SB.object({
        // How many energy we should give
        energy: SB.int().min(0),
        // When was message sent
        sentAt: SB.int(),
      }),
    ),
  }),
};
